import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { LandingBodyComponent } from './landing-body/landing-body.component';

import {PayPageComponent} from './landing-body/pay-page/pay-page.component';

import {AuthorizeNetPageComponent} from './authorize-net-page/authorize-net-page.component';

import {ConfirmPageComponent} from './landing-body/confirm-page/confirm-page.component';

const routes: Routes = [
  {path:"",component:LandingBodyComponent},
  {path:"paynow",component:PayPageComponent},
  {path:"confirmation",component:ConfirmPageComponent},
  {path:"authorizePayment",component:AuthorizeNetPageComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
